import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-logo-grassi',
  templateUrl: './logo-grassi.component.html',
  styleUrls: ['./logo-grassi.component.scss']
})
export class LogoGrassiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
